<template>

    <v-flex md3 xs12 class="tile-wrapper button">

        <v-layout
                class="tile-dimensions"
                :style="getStyle"
                :class="[tileClass, isSelected ? 'elevation-5' : 'elevation-3']"
                column
                align-center
                justify-space-around>

            <v-flex md2 class="check-align">

                <v-icon v-if="isSelected && check" :color="companyId === OVB ? 'var(--v-tileColor-base)' : 'white'" class="tile-check noselect">

                    check

                </v-icon>

            </v-flex>

            <v-flex :style="getStyle">

                <i
                    class="noselect tile-icon material-icons x-large"
                    :class="icon"
                />

            </v-flex>

            <v-flex>

                <span class="label-class">

                    {{label}}

                </span>

            </v-flex>

        </v-layout>

    </v-flex>

</template>
<script>
import { OVB } from '../../modules/Ceg';

export default {
    data() {
        return {
            color: 'white',
            OVB,
        };
    },

    computed: {
        outlined() {
            return this.cfg.props.outlined;
        },
        isSelected() {
            return this.selected;
        },
        tileClass() {
            if (this.isSelected) return 'tile-selected';
            if (this.disabled) return 'tile-disabled';
            return this.outlined ? 'outlined-tile' : 'tile';
        },
        getStyle() {
            return {
                opacity: this.disabled ? '0.3' : '1',
            };
        },
        companyId() {
          return this.$store.getters.companyId;
        }
    },

    props: {
        check: {
            default: false,
        },
        icon: {
            default: '',
        },
        value: {},
        path: {
            type: String,
        },
        label: {
            type: String,
            default: 'Hiba!',
        },
        id: {
            type: Number,
            required: true,
        },
        selected: {
            type: Boolean,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
};
</script>
<style scoped>

.label-class {
    display: block;
    text-align: center;
    font-size: 18px;
    min-width: 70px;
}
.outlined-tile{
    cursor: pointer;
    color: var(--v-tileTextColor-base);
    border: 1px solid var(--v-tileTextColor-base);
}
.tile {
    color: var(--v-tileTextColor-base);
    background: var(--v-tileColor-base);
}

.tile-disabled {
    color: white;
    background: var(--v-tileColor-base);
    user-select: none;
}

.tile:hover {
    cursor: pointer;
}

.tile-selected {
    color: var(--v-tileActiveTextColor-base);
    background: var(--v-tileActiveColor-base);
}

.tile-selected:hover {
    cursor: pointer;
}

.tile-check {
    font-weight: bold;
    /*color: #2789c0;*/
    border-radius: 50%;
    /*background-color: white;*/
    margin-top: 2px;
    margin-right: 2px;
}

.check-align {
    align-self: flex-end;
}

.tile-label {
    color: white;
    background-color: rgba(0, 0, 0, 0.507);
    width: 12vw;
    min-width: 100px;
    font-size: 12px;
    position: relative;
    height: 20px;
    padding: 5px;
}

.tile-dimensions {
    /* width: 12vw;*/
    height: 12vw;
    min-width: 150px;
    min-height: 128px;
    max-height: 137px;
}

.tile-wrapper {
    margin: 5px;
}

.tile-icon {
    font-size: 50px;
    min-height: 50%;
}

.nocheck {
    border-radius: 50%;
    margin-top: 2px;
    margin-right: 2px;
}

</style>
